module.exports = __webpack_public_path__ + "assets/f9a8ee508ceac52c218fe28b50a0d8e0.png";